/* eslint-disable jsx-a11y/anchor-is-valid */
/*
    6/13/2020 - Suhas
    
    This is the header of the Landing page
    It consist of the immediate call number, Logo and the Social Media Links
*/


import React from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Image from "react-bootstrap/Image";
import Card from "react-bootstrap/Card";
import Navbar from "react-bootstrap/Navbar";
import "../css/header.css";
import UserWayAccessibilityMenu from "./UserWayAccessibilityMenu/index";

// Import images
import banner from "../img/header/banner.png";
import logo from "../img/header/logo.svg";
import firstResponder from "../img/header/desktop band.png";
import mobileBanner from "../img/header/mobile-band-view.png";




function Header(props) {
  
  return (
    <>
    <Container fluid>
        <header>
      
            <Row>
              <Col lg={12} className="px-0">
                <Navbar fixed="top" className="rate-title-bg-color justify-content-around">
                  <Navbar.Brand>
                    <Image src={logo} fluid className="swLogo" />
                    
                  </Navbar.Brand>
                  <a
                    href="https://www.swmc.com/ApplyNow/?c=fw&loginByUsingView=GS"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="btn btn-outline-light"
                  >
                    Apply Now
                  </a>
                </Navbar>
              </Col>
              
            </Row>
            <div className="d-flex justify-content-end userwaydivmobile">
            <UserWayAccessibilityMenu
                  color="black"
                  width={40}
                  height={40}
                />
                </div>
            <Row className="bg-white textBlue py-3 justify-content-center">
            
              <Col xs={8} sm={6} lg={12} className="text-center boldText title mb-1 header-d">
                <h1>
                  FRONTLINE <br />
                  WARRIORS
                </h1>
                
                <a
                  href="https://www.swmc.com/ApplyNow/?c=fw&loginByUsingView=GS"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <Image fluid src={mobileBanner} className="w-100" />
                </a>
              </Col>
              
              <Col lg={12} className="text-center">
                <h4>
                  Thank you for serving our community.
                  <br />
                  Now, it&#39;s our turn to serve you!
                </h4>
                <p>
                  <strong>
                    This loan application is exclusively for our nation&#39;s
                    heroes.
                    <br />
                    You have earned and deserve this special $750 closing cost
                    credit/discount.
                  </strong>
                </p>
              </Col>
              <Col lg={12}>
                <p className="text-justify disclaimer">
                  This lender credit is an exclusive offer to the clients on transactions wherein Sun West Mortgage Company, Inc. is the lender. The Lender Credit shall be applied at the time of closing and cannot exceed the actual amount of the eligible fees and program guidelines. This offer is non&#8209;transferable, subject to change or cancellation without notice except as required by law and cannot be combined with any other offer.
                </p>
              </Col>
            </Row>
          
            </header>
      </Container>

      <Card className="banner banner-border d-none d-sm-none d-md-block">
        <Card.Img src={banner} className="mt-n1" />
        <Card.ImgOverlay>
          <Container className="text-center mt-md-3 mt-lg-5" fluid>
            <Row className="justify-content-center">
              <Col xs={5} sm={6} md={5} lg={3}>
                <Image src={logo} className="swLogo" />
              </Col>
            </Row>
            <Row className="justify-content-center">
              <Col
                sm={6}
                md={5}
                lg={4}
                className="textBlue boldText title mb-1"
              >
                FRONTLINE WARRIORS
              </Col>
            </Row>
            <Row className="">
              <Col xs="2"></Col>
              <Col xs="8">
                {/*  eslint-disable-next-line react/jsx-no-target-blank */}
                <a
                  href="https://www.swmc.com/ApplyNow/?c=fw&loginByUsingView=GS"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <Image src={firstResponder} style={{ width: "60%" }} />
                </a>
              </Col>
              <Col xs="2"></Col>
            </Row>
            <Row>
              <Col xs="2"></Col>
              <Col xs="8" className="textBlue boldText tyText">
                Thank you for serving our community.
                <br />
                Now, it&#39;s our turn to serve you!
              </Col>
              <Col xs="2"></Col>
            </Row>
          </Container>
        </Card.ImgOverlay>
      </Card>
    </>
  );
}


export default Header;



